import { isEmpty } from "@swiggy-private/js-utils";
import { GenericCroutonProps, ShowCroutonArgs } from "@swiggy-private/cart-types";

import styles from "./useGenericCrouton.scss";
import { BuildCroutonContentFromDataParams, BuildCroutonRegistrationParams } from "./types";

/**
 * Given an absolute epoch in seconds, returns the remaining duration in whole seconds.
 * Returns 0 when the epoch is absent or already in the past.
 */
export const getRemainingDurationInSec = (timeEpoch?: number): number => {
    // timeEpoch is seconds; compare against Date.now() (ms) via conversion.
    if (isEmpty(timeEpoch) || Number(timeEpoch) * 1000 < Date.now()) {
        return 0;
    }
    return Math.round(Number(timeEpoch) - Date.now() / 1000);
};

/** Shared classNames applied across generic crouton registrations. */
export const GENERIC_CROUTON_CLASS_NAMES = {
    wrapperClassName: styles.genericCrouton,
    iconClassName: styles.genericCroutonIcon,
    titleClassName: styles.genericCroutonText,
    buttonClassName: styles.genericCroutonBtn,
    timerClassName: styles.genericCroutonTimer,
};

/**
 * Maps the fields shared by data-driven generic croutons (RX, timed free cash,
 * magic items, default). Type-specific extras (subText, backgroundColor, etc.)
 * stay at the call site so payloads stay behaviorally identical.
 */
export const buildCroutonContentFromData = ({
    data,
    durationInSec,
    setCroutonVisibility,
}: BuildCroutonContentFromDataParams): GenericCroutonProps =>
    ({
        title: data?.text,
        icon: data?.icon || "",
        showTimer: data?.showTimer,
        duration: !isEmpty(data?.endTimestamp) ? durationInSec : data?.timer,
        durationOfCrouton: data?.timeout,
        setCroutonVisibility,
        timerTextColor: data?.timerTextColor,
        textColor: data?.textColor,
    }) as GenericCroutonProps;

/** Common util to assemble a crouton registration payload. */
export const buildCroutonRegistration = ({
    type,
    index,
    content,
    forceRefreshContent = true,
}: BuildCroutonRegistrationParams): ShowCroutonArgs => ({
    id: type,
    priority: index + 1,
    content: content as GenericCroutonProps,
    forceRefreshContent,
});
